<template>
    <span>
        <img
            v-if="avatarUrl"
            class="w-full border border-gray-300 h-full rounded-full"
            :src="avatarUrl"
            :alt="`${projectname} Avatar`"
        />
        <avatar
            v-else
            :custom-style="{ width: '100%', height: '100%', fontSize: fontSizes[size] }"
            :username="projectname"
        ></avatar>
    </span>
</template>

<script>
export default {
    props: {
        projectname: {
            type: String,
            required: true
        },
        avatarUrl: {
            type: String,
            default: null
        },
        size: {
            type: String,
            default: 'md'
        }
    },

    data() {
        return {
            fontSizes: {
                md: 'auto',
                lg: '60px'
            }
        };
    }
};
</script>
